import { useLocation } from "react-router";
import { useEffect } from "react";
import { getProjectData, getProjectNameFromPath } from "../../data/util.js";
import "./Work.css";

export default function Shows() {
  const { pathname } = useLocation();

  const projectName = getProjectNameFromPath(pathname);

  const { images, author, title } = getProjectData(projectName);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="header-green">{title}</div>
      <div className="show-images">by {author}</div>
      <div className="show-images">
        {images.map((img, index) => {
          return (
            <img
              key={index}
              src={img.url}
              alt={img.alt}
              className="showimage"
            />
          );
        })}
      </div>
    </>
  );
}
